
// @aigc:start 2024/12/04-18:44
/**
 * 只能使用汉字、数字、字母
 */
export const wordAndNumberAllowedReg = new RegExp(/^[a-zA-Z0-9\u4e00-\u9fa5·\s]+$/, 'i');

/**
 * 只能使用汉字、数字、字母、标点符号
 */
export const wordAndNumberAndSymbolAllowedReg = new RegExp(/^[a-zA-Z0-9\u4e00-\u9fa5\.\^\-\*，。？！：、……“”；‘’（）《》〈〉［］【】——｛｝～#@%+｀+‖=,?!:/";'()<>[\]{}`~*#@%+´_|﹉|=＄&｜＋＝¥$ \s]+$/, 'i');
// @aigc:end 2024/12/04-18:44


// @aigc:start 2024/12/04-18:44
/**
 * 获取地址和姓名正则表达式的错误提示
 */
export const getAddressAndUserNameToastTitle = (address, username) => {
  if (!wordAndNumberAndSymbolAllowedReg.test(address)) {
    return '详细地址只能使用汉字、数字、字母、标点符号';
  }
  if (!wordAndNumberAllowedReg.test(username)) {
    return '收件人只能使用汉字、数字、字母';
  }
  return '';
};
// @aigc:end 2024/12/04-18:44
